const initialState = {
  devices: [],
  // locations: [],
  // timezones: [],
  selectedRows: [],
  initialFetchIsDone: false,
  loading: true,
  perPage: 20,
  page: 0,
  totalItems: 0,
  qs: "",
};

export default initialState;
